import React, { useState } from "react";

type Props = {
  name: string;
  value: string;
  link: string;
  linkName?: string;
  logo: React.ReactNode;
  editable?: boolean;
  onChange?: (value: string) => void;
};

const SocialInput: React.FC<Props> = ({
  value,
  name,
  link,
  linkName,
  logo,
  editable = false,
  onChange,
}) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");

  const handleSave = () => {
    if (onChange) {
      onChange(inputValue);
    }
    setEditing(false);
  };

  const handleCancel = () => {
    setInputValue(value || "");
    setEditing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleSave();
    if (e.key === "Escape") handleCancel();
  };

  return (
    <div className="media text-muted pt-3">
      {logo}
      <div className="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
        <div className="d-flex justify-content-between align-items-center w-100">
          <strong className="text-gray-dark text-capitalize">{name}</strong>
          {editable && !editing && (
            <button
              type="button"
              className="btn btn-link btn-sm text-capitalize text-primary"
              onClick={() => setEditing(true)}
            >
              Cambiar
            </button>
          )}
        </div>
        {editing ? (
          <div className="d-flex align-items-center mt-1">
            <input
              className="form-control form-control-sm mr-2"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyPress}
              autoFocus
            />
            <button
              type="button"
              className="btn btn-sm btn-success mr-1"
              onClick={handleSave}
            >
              <i className="fas fa-check"></i>
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleCancel}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        ) : (
          <span className="d-block">
            <a
              className="text-muted form_foo"
              href={link}
              target="_blank"
              rel="noreferrer"
            >
              {linkName || link}
            </a>
          </span>
        )}
      </div>
    </div>
  );
};

export default SocialInput;
